// @flow

import React from 'react'
import { StoreProvider } from 'easy-peasy'

import { store } from '../../../../store'

import { TempLoginPanel } from './TempLoginPanel'

export default function LoginPage () {
  return (
    <StoreProvider store={store}>
      <TempLoginPanel />
    </StoreProvider>
  )
}
